<ng-container *ngIf="bootstrapProperties$ | async as bootstrapProperties">
	<div id="banner" *ngIf="bootstrapProperties.bannerEnabled">
		<span class="secondary" [innerHtml]="'global.main.bannerLeftRightText' | translate | safe : 'html'"></span
		><span class="primary" [innerHtml]="'global.main.bannerCenterText' | translate | safe : 'html'"></span
		><span class="secondary" [innerHtml]="'global.main.bannerLeftRightText' | translate | safe : 'html'"></span>
	</div>
	<div class="login">
		<div class="wrapper">
			<article class="card">
				<header>
					<h1 translate="login"></h1>
					<div class="logo">
						<span class="img stages"></span>
					</div>
				</header>

				<form [formGroup]="form" role="form">
					<div class="field errors" *ngIf="getErrorMessages(bootstrapProperties) as errorMessage">
						<div class="error">
							<span [translate]="errorMessage.key" [translateParams]="errorMessage.args"></span>
						</div>
					</div>

					<ng-container *ngIf="bootstrapProperties.samlAuthenticationEnabled">
						<div class="field saml">
							<div class="login-button max">
								<button
									[disabled]="isRequestRunning() || isSSORequestRunning()"
									type="button"
									(click)="samlAuthentication()"
									class="button lg prime"
									translate="login.sso"
								></button>
							</div>
							<div class="error" *ngIf="samlErrors" [translate]="samlErrors"></div>
							<div class="divider" *ngIf="bootstrapProperties.basicAuthenticationEnabled">
								<span translate="login.or"></span>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="bootstrapProperties.basicAuthenticationEnabled">
						<div class="field">
							<label for="username" [translate]="'login.username'"></label>
							<input
								formControlName="username"
								type="text"
								id="username"
								name="username"
								class="text username"
								stagesAutofocus
								required
								autocapitalize="none"
								autocomplete="username"
							/>
							<div
								*ngIf="submitted && form.get('username')!.errors?.required"
								class="error"
								role="alert"
								translate="input.required"
							></div>
						</div>

						<div class="field">
							<label for="password" [translate]="'login.password'"></label>
							<input
								#passwordInput
								formControlName="password"
								type="password"
								id="password"
								name="password"
								class="text password"
								(focus)="$any($event.target).select()"
								required
								autocomplete="off"
							/>
							<div
								*ngIf="submitted && form.get('password')!.errors?.required"
								class="error"
								role="alert"
								translate="input.required"
							></div>
							<ng-container *ngIf="(factor2$ | async) === 'NONE'; then showErrors"></ng-container>
						</div>

						<div class="row" *ngIf="captchaImage">
							<div class="field">
								<label for="captchaText" [translate]="'login.captcha'"></label>
								<div>
									<input
										formControlName="captchaText"
										type="text"
										id="captchaText"
										name="captchaText"
										class="text captcha"
										stagesAutofocus
										autocapitalize="none"
										autocomplete="username"
									/>
									<img [src]="'data:image/png;base64,' + captchaImage" alt="captcha-image" class="captcha-image" />
								</div>
							</div>
						</div>

						<ng-container *ngIf="factor2$ | async as otpType">
							<div class="field" *ngIf="otpType === 'HOTP' || otpType === 'TOTP'">
								<label for="code" [translate]="'login.code.' + otpType"></label>
								<input
									#codeInput
									[stagesAutofocus]
									formControlName="code"
									type="text"
									id="code"
									name="code"
									class="text"
									required
									inputmode="numeric"
									pattern="[0-9]*"
									autocomplete="one-time-code"
									(focus)="$any($event.target).select()"
								/>
								<div
									*ngIf="codeSubmitted && form.get('code')!.errors?.required"
									class="error"
									role="alert"
									translate="input.required"
								></div>
								<ng-container *ngIf="(factor2$ | async) !== 'NONE'; then showErrors"></ng-container>
							</div>
						</ng-container>
						<div class="row">
							<div
								class="field"
								*ngIf="bootstrapProperties.cookieLoginEnabled && !bootstrapProperties.samlAuthenticationEnabled"
							>
								<input
									formControlName="rememberUser"
									type="checkbox"
									id="remember-me"
									name="remember-me"
									class="checkbox"
								/><label for="remember-me" [translate]="'login.autologin'"></label>
							</div>
						</div>

						<div class="login-button max" [ngSwitch]="isRequestRunning()">
							<button
								[disabled]="isSSORequestRunning()"
								*ngSwitchCase="false"
								(click)="passwordAuthentication()"
								class="button lg prime"
								[ngClass]="{ outlined: bootstrapProperties.samlAuthenticationEnabled }"
								translate="login.submit"
							></button>
							<button
								[disabled]="true"
								*ngSwitchCase="true"
								class="button lg prime"
								[ngClass]="{ outlined: bootstrapProperties.samlAuthenticationEnabled }"
							>
								<stages-spin size="s"></stages-spin>
							</button>
						</div>
					</ng-container>
					<div class="row helpdesk" *ngIf="!!helpDeskInformation || !!helpDeskLinkHref">
						<p>
							<span *ngIf="!!helpDeskInformation">{{ helpDeskInformation }}&nbsp;</span
							><a *ngIf="!!helpDeskLinkHref" target="_blank" href="{{ getHrefForExternalLink(helpDeskLinkHref) }}"
								><span *ngIf="!!helpDeskLinkText">{{ helpDeskLinkText }}</span
								><span *ngIf="!helpDeskLinkText">{{ helpDeskLinkText }}</span></a
							>
						</p>
					</div>
				</form>
			</article>
		</div>
	</div>
</ng-container>

<ng-template #showErrors>
	<div class="error" *ngIf="errors" [translate]="errors"></div>
</ng-template>
